<template>
	<div>
		<el-dialog title="确认表" width="900px" :visible.sync="visible" :close-on-click-modal="false" @close="closeDialog">
			<div style="text-align: right; position: absolute; top:20px; right: 100px;">
				<el-button v-print="'#printMe'" icon="el-icon-printer" type="primary">打印</el-button>
			</div>
			<div>
				<div id="printMe" style="width:750px; margin: 0 auto; position: relative; ">
					<div style=" width: 100%; height: 1063px;">
						<img src="/images/querenbiao3.png" style="width: 100%; height: 100%;" />
					</div>
					<div style="position: absolute;top: 0; z-index: 9;">
						<div class="fitem" style="top: 76px;left: 175px;">
							{{ stuinfo.stu_code }}
						</div>

						<div class="fitem" style="top: 76px;left: 506px; width: 170px;">
							{{ stuinfo.stu_name }}
						</div>

						<div class="fitem" style="top: 115px;left: 175px;">
							{{ stuinfo.identity_card }}
						</div>

						<div class="fitem" style="top: 115px;left: 506px; width: 175px;">
							{{ stuinfo.gender == 1 ? '男' : '女' }}
						</div>



						<div class="fitem" style="top: 155px;left: 175px;">
							{{ stuinfo.archive }}
						</div>

						<div class="fitem" style="top: 155px;left: 506px; width: 175px;">
							{{ stuinfo.exam_num }}
						</div>


						<div class="fitem "
							style="top: 195px;left: 180px; overflow: hidden;font-size: 14px;  line-height: initial;">
							<div class="flexBetween" style="width:100%;height:100%">
								{{ stuinfo.graduate_schname }}
							</div>

						</div>

						<div class="fitem" style="top: 195px;left: 506px; width: 175px;">
							{{ stuinfo.exam_score }}
						</div>

						<div class="fitem" style="top: 235px;left: 175px;width: 500px;">
							{{ stuinfo.major_name }}
						</div>
						<div class="fitem" style="top: 275px;left: 175px;width: 500px;">
							{{ stuinfo.hkszd }}
						</div>
						<div class="fitem" style="top: 315px;left: 175px;">
							{{ stuinfo.cdate }}
						</div>

						<div class="fitem" style="top: 315px;left: 506px; width: 175px;">
							{{ stuinfo.phone }}
						</div>

						<div class="fitem" style="top: 355px;left: 175px;">
							{{ stuinfo.jhr1name }}
						</div>

						<div class="fitem" style="top: 355px;left: 506px; width: 175px;">
							{{ stuinfo.jhr1phone }}
						</div>

						<div class="fitem" style="top: 395px;left: 175px;">
							<div v-if="stuinfo.volunteer == 1"
								style="width: 15px; line-height: 15px; height: 15px; position: absolute; top: 14px; left: 16px;">
								✔
							</div>
							<div v-if="stuinfo.volunteer == 2"
								style="width: 15px; line-height: 15px; height: 15px; position: absolute; top: 14px; left: 90px;">
								✔
							</div>
							<div v-if="stuinfo.volunteer == 0"
								style="width: 15px; line-height: 15px; height: 15px; position: absolute; top: 14px; left: 158px;">
								✔
							</div>
						</div>

					</div>
				</div>

			</div>


		</el-dialog>
	</div>
</template>

<script>
export default {
	props: ["stuinfo"],
	data() {
		return {
			visible: true,
			closing: false

		}
	},
	mounted() {


	},
	methods: {

		closeDialog() {

			this.visible = false;

			setTimeout(() => {
				this.$parent.showQrb = false;

			}, 250)
		}
	}
}
</script>

<style scoped>
.fitem {
	position: absolute;

	height: 38px;
	width: 220px;
	line-height: 44px;
	font-size: 18px;
	text-align: center;
	/* background-color: rgba(0, 0, 0, 0.5); */
}
</style>
